import React, { useState } from 'react';
import { IconButton, InputAdornment, TextField } from 'components/ui';
import { Visibility, VisibilityOff } from 'components/uiIcons';

const Password = (field) => {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <TextField
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={toggleShowPassword} edge="end">
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...field}
    />
  );
};

export default Password;
